const nameToSize = {
  xsmall: '0.75rem',
  small: '0.875rem',
  normal: '1rem',
  medium: '1.25rem',
  large: '1.5rem',
  xlarge: '2rem',
  xxlarge: '3rem',
  xxxlarge: '4rem'
};
export const getSize = size => nameToSize[size] ? nameToSize[size] : size;